module.exports = __webpack_public_path__ + "static/media/WafangdianBearing.982aa84e.png";